import { useIntl, type MessageDescriptor as BaseMessageDescriptor } from '@olxpwa-lib/i18n/client';
import type { Messages } from '../types';

// TODO remove this once react-intl is upgraded to support FormatjsIntl.Message['ids']
type PrimitiveType = string | number | boolean | null | undefined | Date;
type FormatXMLElementFn = (...args: any[]) => string | object;
type MessageDescriptor = Omit<BaseMessageDescriptor, 'id'> & {
  id: Messages;
};

type FormatMessageFn = (
  descriptor: MessageDescriptor,
  values?: Record<string, PrimitiveType | React.ReactElement | FormatXMLElementFn>,
) => string | React.ReactNodeArray;

export const useFormatMessage = () => {
  const { formatMessage } = useIntl();

  return formatMessage as unknown as FormatMessageFn;
};
